import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 2200. 発注ダッシュボード（担当者別ランキング）
 * [GET] /workspaces/:identifier/purchase_dashboard/amount_by_user
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  product_ids?: number[];
  sales_context_ids?: number[];
};

export type PurchaseDashboardAmountByUser = {
  total_amount: number;
  user_rankings: { name: string; total_amount: number; contracted_amount: number }[];
};

const purchaseDashboardAmountByUser = (props: Props): Promise<PurchaseDashboardAmountByUser> => {
  return axios.get(`/api/workspaces/${props.identifier}/purchase_dashboard/amount_by_user`, { params: props });
};

export const usePurchaseDashboardAmountByUser = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'purchase_dashboard', 'amount_by_user', { ...props }],
    queryFn: () => purchaseDashboardAmountByUser(props),
    staleTime: 1000 * 60 * 30,
  });
};
